export enum SocketEventTypes {
  WalletUpdate = "WalletUpdate",
  TicketAccepted = "TicketAccepted",
}
